import { render } from "./IconCustom.vue?vue&type=template&id=a46663ee"
import script from "./IconCustom.vue?vue&type=script&lang=js"
export * from "./IconCustom.vue?vue&type=script&lang=js"

import "./IconCustom.vue?vue&type=style&index=0&id=a46663ee&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__